import type {
  CreateLinkChapterCommand,
  LinkChapterDto,
  PaginatedListOfLinkChapterDto,
  UpdateLinkChapterCommand
} from "../models/models"
import type { HttpResponse } from "../redux/http/http.types"
import type { LinkChapter } from "../redux/linkchapters/linkchapter.types"
import { dispatchSnackbar } from "../services/SnackbarService"
import { hasFailed } from "../utils"
import { get, post, put, remove } from "./HttpService"

export async function postLinkChapter(chapter: LinkChapter): Promise<string> {
  const command: CreateLinkChapterCommand = {
    name: chapter.name,
    thumbnailAssetId: chapter.thumbnailUrl,
    url: chapter.url,
    order: chapter.order,
    zone: chapter.zone,
    licenceIds: chapter.licenceIds
  }
  const response: HttpResponse<string> = await post<string, CreateLinkChapterCommand>(
    "linkChapter",
    "linkChapters",
    command
  )

  dispatchSnackbar("hoofdstuk", "POST", !hasFailed(response))

  return response.data!
}

export async function getAllLinkChapters(queryString: string): Promise<PaginatedListOfLinkChapterDto> {
  const response: HttpResponse<PaginatedListOfLinkChapterDto> = await get<PaginatedListOfLinkChapterDto>(
    "linkChapter",
    `linkChapters${queryString}`
  )

  return response.data!
}

export async function getLinkChapter(id: string): Promise<LinkChapterDto> {
  const response: HttpResponse<LinkChapterDto> = await get<LinkChapterDto>("linkChapter", `linkChapters/${id}`)
  return response.data!
}

export async function putLinkChapter(chapter: LinkChapter): Promise<void> {
  const command: UpdateLinkChapterCommand = {
    id: chapter.id as string,
    name: chapter.name,
    thumbnailAssetId: chapter.thumbnailUrl,
    url: chapter.url,
    order: chapter.order,
    zone: chapter.zone,
    licenceIds: chapter.licenceIds
  }

  const response: HttpResponse = await put<UpdateLinkChapterCommand>("linkChapter", "linkChapters", command)

  dispatchSnackbar("hoofdstuk", "PUT", !hasFailed(response))
}

export async function removeLinkChapter(id: string): Promise<void> {
  const response: HttpResponse = await remove("linkChapter", `linkChapters/${id}`)

  dispatchSnackbar("hoofdstuk", "DELETE", !hasFailed(response))
}
